import React, { useState } from 'react';
import clientService from 'services/http/client-service';
import utils from 'utils';
import { ClientEditionForm } from 'components/pages/client-management/client-info-edit';
import { useHistory } from 'react-router';
import { CustomButton, SkeletonLoader, UserAvatar, WithLoadingComponent } from 'components/shared';


const ClientChip = (props) => {

    const [displayEditForm, setDisplayEditForm] = useState(false);
    const [refreshClient, setRefreshClient] = useState({ loading: false, data: null, error: null });
    const history = useHistory();
    const [clientInfo, setClientInfo] = useState(props.data);

    //CLIENT LABEL INFORMATION
    const FieldTemplate = (props) => {
        return (
            <div className="d-flex">
                {props.value && <><small className='meta-field-customer'>{props.label} </small><small className="customer-field" style={{ whiteSpace: `${props.whiteSpace || "nowrap"}` }}>{props.value}</small></>}
            </div>
        );
    }

    const refreshClientInfo = () => {
        setRefreshClient({ ...refreshClient, loading: true });
        clientService.refreshClientInfo(clientInfo.clientId, props.task.source.sourceId).then((response) => {
            setRefreshClient({ ...refreshClient, data: response.result });
            setClientInfo(response.result);
            let updateTask = JSON.parse(new URLSearchParams(window.location.search).get("task"));
            updateTask['client'] = response.result;
            utils.pushURLSearchParams(history, "task", JSON.stringify(updateTask));
        }, error => {
            setRefreshClient({ ...refreshClient, error: error });
        });
    }

    //CUSTOMER CHIP FIX OVERLAPPING
    props.taskView && utils.fixContainersOverlaping(".customer-container");

    const CLIENT_FIELDS = [
        { label: "FIRST NAME", value: clientInfo.firstname },
        { label: "LAST NAME", value: clientInfo.lastname },
        { label: "EMAIL", value: clientInfo.email },
        { label: "PHONE Ooredoo", value: clientInfo.phoneNumber },
        { label: "PHONE Ooredoo 2", value: clientInfo.phoneNumber2 },
        { label: "N° Contrat BSCS", value: clientInfo.bscsContract },
        { label: "GPS Coordinates", value: clientInfo.gps },
        { label: "DATE OF BIRTH", value: clientInfo.birthday ? new Date(clientInfo.birthday).toLocaleDateString() : null },
        { label: "WILAYA", value: clientInfo.wilaya?.wilayaName },
        { label: "COMMUNE", value: clientInfo.commune?.communeName },
        { label: "ADDRESS", value: clientInfo.adress },
        { label: "Comment", value: clientInfo.comments }
    ]

    return (
        <div className="scroll-container customer-container">
            {
                <div className='customer-content mui-chip mb-3 '>
                    <div className="d-flex justify-content-between">
                        <div className="float-left">
                            {CLIENT_FIELDS.map(item => <FieldTemplate {...item} />)}
                        </div>
                        <div className="float-right">
                            <UserAvatar image={clientInfo.profilePic} size="xlarge" shape="square" className="client-image" />
                        </div>
                    </div>
                    <hr />
                    {clientInfo.updateDate && <FieldTemplate label="LAST UPDATE" value={`${new Date(clientInfo.updateDate).toLocaleString()} by ${clientInfo.updatedBy?.toUpperCase()}`} />}
                </div>
            }
            {
                !displayEditForm &&
                <div className="text-center">
                    <CustomButton
                        label={<><i className="bi bi-pencil" /> Edit Client Info</>}
                        onClick={() => { setDisplayEditForm(true) }}
                        style={{ width: "40%" }} />
                    &nbsp;
                    <CustomButton
                        style={{ width: "40%" }}
                        label={utils.labelTemplate(<><i className="pi pi-refresh" /> Synchronise Client</>, false, "Processing...")}
                        onClick={refreshClientInfo}
                        disabled={refreshClient.loading}
                        className={refreshClient.loading && "not-allowed"} />
                </div>
            }
            {
                displayEditForm &&
                <ClientEditionForm
                    client={clientInfo}
                    onEditCallback={(client) => { setDisplayEditForm(false); setClientInfo(client) }}
                    dismissEditForm={() => setDisplayEditForm(false)}
                    taskView={props.taskView} />

            }
        </div>
    );
}

export const ClientChipHoc = ((props) => {
    const ClientHoc = React.useMemo(() => WithLoadingComponent(ClientChip, () => clientService.getClientInfo(props.task.client.clientId), <SkeletonLoader factor={4} />)(props), [props.task.client.clientId]);
    return <ClientHoc />;
});
